import { AnyRouter } from '@tanstack/react-router'
import { makeObservable, observable } from 'mobx'

import { ExtendedClientAppTypeSchema } from '@campai/lib-common/entities'
import { Notifications, WatchCounters, WebAppState } from '@campai/lib-web/appState'
import { getGlobalInstance } from '@campai/lib-web/utils/state'
import { client } from '@campai/lib-web/utils/trpc'

export class AppState extends WebAppState {
    readonly watchCounters = new WatchCounters({
        target: 'root',
        subscribe: (input, observer) => client.currentUser.watchCounters.subscribe(input, observer),
    })
    readonly notifications = new Notifications({
        target: 'root',
        getWatchCounter: () => this.watchCounters.notifications,
    })
    isNotificationsVisible = false

    constructor() {
        super({ clientApp: ExtendedClientAppTypeSchema.enum.root })

        makeObservable(this, {
            watchCounters: observable.ref,
            notifications: observable.ref,
            isNotificationsVisible: observable,
        })
    }

    async init() {
        const router = getGlobalInstance<AnyRouter>('router')

        await super.init({
            forceUser: true,
            router,
            registerForWebPush: true,
        })

        this.watchCounters.start()
    }
}
